/**
 * Gedeelde NL-notatie-helpers (thousands = punt, decimaal = komma).
 * bv. formatNL(58452.34) → "58.452,34"
 */
export const formatNL = (n, decimals = 2) => {
  if (n === null || n === undefined || Number.isNaN(Number(n))) return '–';
  return new Intl.NumberFormat('nl-NL', {
    minimumFractionDigits: decimals,
    maximumFractionDigits: decimals,
  }).format(Number(n));
};

export const formatInt = (n) => formatNL(n, 0);

export const formatDate = (date, options = { day: 'numeric', month: 'short', year: 'numeric' }) => {
  if (!date) return '';
  try {
    return new Date(date).toLocaleDateString('nl-NL', options);
  } catch {
    return '';
  }
};

export const MONTH_NAMES_NL = [
  'Januari', 'Februari', 'Maart', 'April', 'Mei', 'Juni',
  'Juli', 'Augustus', 'September', 'Oktober', 'November', 'December',
];
